import { render, staticRenderFns } from "./box-view-skeleton-loader.vue?vue&type=template&id=3cbf89d5&"
import script from "./box-view-skeleton-loader.vue?vue&type=script&lang=js&"
export * from "./box-view-skeleton-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports